/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} VerifiedInputs */

const en_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified`)
};

const es_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificado`)
};

const fr_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifié`)
};

const de_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiziert`)
};

const ja_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認済み`)
};

const zh_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已验证`)
};

const ar_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موثق`)
};

const id_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terverifikasi`)
};

const it_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificato`)
};

const ru_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтверждено`)
};

const pt_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificado`)
};

const ko_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증됨`)
};

/**
* | output |
* | --- |
* | "Verified" |
*
* @param {VerifiedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verified = /** @type {((inputs?: VerifiedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<VerifiedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verified(inputs)
	if (locale === "es") return es_verified(inputs)
	if (locale === "fr") return fr_verified(inputs)
	if (locale === "de") return de_verified(inputs)
	if (locale === "ja") return ja_verified(inputs)
	if (locale === "zh") return zh_verified(inputs)
	if (locale === "ar") return ar_verified(inputs)
	if (locale === "id") return id_verified(inputs)
	if (locale === "it") return it_verified(inputs)
	if (locale === "ru") return ru_verified(inputs)
	if (locale === "pt") return pt_verified(inputs)
	return ko_verified(inputs)
});